import { getAxiosInstance } from "../ApiConfig";

const LoginToken = localStorage.getItem('cx_token');
const headers = {};
headers.Authorization = `Bearer ${LoginToken}`;

async function FetchAllCampaignByCompany() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllCampaignByCompany`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchAllCampaignByCreatedBy(page, limit) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllCampaignByCreatedBy${page ? `?page=${page}&limit=${limit}` : ''}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchCampaignType() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllCampaignType`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchCampaignStatus() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllCampaignStatus`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function CampaignSave(payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/createCampaign`, payload, { headers });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function CampaignUpdate(payload, id) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/updateCampaign/${id}`, payload, { headers });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function CampaignDetails(id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findOnebyCampaignId/${id}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function CampaignDelete(id) {
    try {
        const data = await getAxiosInstance().delete(`/usermgmt/deleteCampaign/${id}`, { headers });
        return data
    } catch (err) {
        throw err.response.data.message.message;
    }
}

export {
    FetchAllCampaignByCompany,
    FetchAllCampaignByCreatedBy,
    FetchCampaignType,
    FetchCampaignStatus,
    CampaignSave,
    CampaignUpdate,
    CampaignDetails,
    CampaignDelete
}